function PageHero() {
  return (
    <section className="page-hero">
      <div className="container">
        <span className="section-badge">TRAINING & INTERNSHIP</span>
        <h1 className="section-title">Our Training & Internship Program</h1>

        <nav className="breadcrumb" aria-label="Breadcrumb">
          <a href="/">HOME</a>
          <span className="breadcrumb-separator">&gt;</span>
          <span className="breadcrumb-current">TRAINING & INTERNSHIP</span>
        </nav>
      </div>
    </section>
  );
}

export default PageHero;
